import { render, staticRenderFns } from "./InSwitchLED65LessSplit.vue?vue&type=template&id=5c26a64e&scoped=true&"
import script from "./InSwitchLED65LessSplit.vue?vue&type=script&lang=js&"
export * from "./InSwitchLED65LessSplit.vue?vue&type=script&lang=js&"
import style0 from "./InSwitchLED65LessSplit.vue?vue&type=style&index=0&id=5c26a64e&lang=scss&scoped=true&"
import style1 from "./InSwitchLED65LessSplit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c26a64e",
  null
  
)

export default component.exports